import { Component, HostListener, OnInit } from '@angular/core';
import { ApiHttpService } from 'src/app/core/services/apiHttpcall.service';
import { Response } from 'src/app/shared/interfaces/response';
import { LegHistoryData } from './leg-history.interface';
import { UtilService } from 'src/app/core/services/util.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'trip-leg-history',
  templateUrl: './leg-history.component.html',
  styleUrls: ['./leg-history.component.scss']
})
export class LegHistoryComponent implements OnInit {
  visibility: boolean = false;
  title: string;
  data: LegHistoryData;
  date: string;

  constructor(
    // private readonly httpService: ApiHttpService,
    private readonly dialogService: DialogService,
    // private uiLoaderService: NgxSpinnerService,
  ) { }

  @HostListener('document:keydown.escape', ['$event'])
  onEscPressed(event: KeyboardEvent) {
    if (this.dialogService.isTopMost(this)) {
      this.hide();
    }
  }

  ngOnInit() { }

  hide() {
    this.visibility = false;
    this.dialogService.unregisterDialog(this);
  }

  show() {
    this.visibility = true;
    this.dialogService.registerDialog(this);
    console.log('leg history data:', this.data);
  }

  // async getDetails(endpoint: string) {
  //   console.log({endpoint});
  //   if(!endpoint) return;
  //   this.uiLoaderService.show();
  //   const res = await this.httpService.get(`/${endpoint}`) as Response<LegHistoryData>;
  //   if(res) this.uiLoaderService.hide();
  //   if (res.status == 200) {
  //     this.data = res.data;
  //   }
  //   console.log(res);
  // }
}
